import React, { Component } from 'react';
import './card-wrapper.css';

class GeckoCardWrapper extends Component {

    render() {
		return (
            <div className={'card gecko-card clearfix ' + this.props.className}>
                {this.props.children}
            </div>
        );
    }
}

GeckoCardWrapper.defaultProps = {
	className: '',
}	

export default GeckoCardWrapper;